'use client';

import customAlert from '@/util/customAlert';
import { useContext, useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import addhome_ko from "@/public/image/etc/add_home_ko.png"
import addhome_en from "@/public/image/etc/add_home_en.png"
import { SignContext } from '@/context/signContext';
import { DeviceContext } from '@/context/deviceContext';
import redirectInappToChrome from '@/util/redirectInappToChrome';
import { useLocale, useTranslations } from 'next-intl';

export default function PWAInstallButton() {
    const {mobileMode} = useContext(DeviceContext)
    const [deferredPrompt, setDeferredPrompt] = useState<any>(null);
    const [isVisible, setIsVisible] = useState(false);
    const {IOSPopupShow, setIOSPopupShow } = useContext(SignContext)

    const locale = useLocale();
    const a = useTranslations("Sentence")


    // iOS Safari 감지
    const isIos = () => {
        const userAgent = window.navigator.userAgent.toLowerCase();
        return /iphone|ipad|ipod/.test(userAgent);
    };
    // const isInStandaloneMode = () =>
    //     'standalone' in window.navigator && (window.navigator as any).standalone;

    // const isInStandaloneMode = () =>
    //     (window.matchMedia('(display-mode: standalone)').matches) ||
    //     ('standalone' in window.navigator && (window.navigator as any).standalone);

    const isInStandaloneMode = () => {
        return (
            // 아이폰
            ('standalone' in window.navigator && (window.navigator as any).standalone) ||
            // 이ㅏㄴ드로읻,
            window.matchMedia('(display-mode: standalone)').matches
        );
    };



    useEffect(() => {
        // if (isMobile) setIsVisible(true);

        if (isInStandaloneMode()) {
            setIsVisible(false)
            return;
        }else{
            if(mobileMode){
                setIsVisible(true)
            }
            
        }

        const handler = (e: Event) => {
            e.preventDefault();
            setDeferredPrompt(e);
        };

        window.addEventListener('beforeinstallprompt', handler as EventListener);

        return () => {
            window.removeEventListener('beforeinstallprompt', handler as EventListener);
        };
    }, []);

    const handleInstallClick = async () => {
        // console.log(deferredPrompt)
            // test
            // setIOSPopupShow(true)
        if (isIos() && !isInStandaloneMode()) {
            setIOSPopupShow(true)
            // customAlert('홈 화면에 추가하려면 Safari 하단 공유 버튼을 누르고 "홈 화면에 추가"를 선택하세요.', 'warning')0
            return;
        }

        if (!deferredPrompt){
            // 크롬, 사파리를 제외한 다른 브라우저
            customAlert((a.rich("unsupportedA2HS", { br: (c)=> <br /> }) as string), 'warning',
                ()=>{ redirectInappToChrome(false, locale) }, { htmlMode: true }
            )
            return;
        }

        // 설치 팝업 띄우기
        deferredPrompt.prompt();

        const choiceResult = await deferredPrompt.userChoice;
// console.log('User response:', choiceResult.outcome);

        // 설치 버튼 숨기기
        setDeferredPrompt(null);
        // setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <button
            onClick={handleInstallClick}
            className="pwa-button" >
                <img src={`image/etc/add_home_${locale}.png`} alt="" />
            {/* 홈 화면에 설치 */}
        </button>
    );
};